import * as React from 'react';

export function MarketingTemplate({ item }) {
	if (item.label && !item.url) {
		return <p>{item.label}</p>;
	}
	return (
		<button type="button" aria-label={item.label}>
			<a href={item.url}>{item.label}</a>
		</button>
	);
}

export function getMarketingTemplateConfig(sourceId, items, templates) {
	return {
		sourceId,
		getItems: () => items,
		templates,
	};
}

export const marketingItems = [
	{
		label: "I'm looking for...",
		value: 'looking',
	},
	{
		label: 'Designations',
		value: 'designations',
		url: '/designations',
	},
	{
		label: 'Sample Courses',
		value: 'micro-courses',
		url: '/free-courses',
	},
	{
		label: 'Online Courses',
		value: 'online-courses',
		url: '/risk-and-insurance-topic-courses',
	},
	{
		label: 'CEU',
		value: 'ceu',
		url: '/ceu',
	},
];
